import { ImagePosition } from '@/app/shared/images'

export const styles = {
  base: 'data-[open=true]:bg-content1-200 data-[open=true]:text-secondary hover:bg-content1-200 hover:text-secondary transition border-b-2 px-2.5 !hover:[*]:text-warning [&~hr]:h-0 [&:first-child]:border-y-2 border-content1-600',
  content: 'p-0 pb-2.5',
  trigger: 'h-[56px] hover:text-secondary',
  indicator: 'text-inherit',
}

export const dataPosition = {
  name: 'Оболонь',
  image: ImagePosition,
  isOpen: true,
  address: 'м. Київ, проспект Оболонський, 16',
  schedule: ['пн.-пт. 10:00-21:00', 'сб. 10:00-18:00'],
  additional: ['light', 'wifi', 'air-conditioning'],
  link: 'https://google.com',
}
